import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const outboundTruckApi = {
    createTruck: async (item) => {
        const url = `api/logistics/v1/outbound/trucks`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
        return response;
    },
    getDoors: async (facilityID) => {
        const url = `api/logistics/v1/outbound/doors?facility=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getManifestableTrucks: async (facilityID) => {
        const url = `api/logistics/v1/outbound/manifestableTrucks?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getTrucks: async (facilityID) => {
        const url = `api/logistics/v1/outbound/trucks?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getTruckDelayReasons: async () => {
        const url = `api/logistics/v1/outbound/truckDelayReasons`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getDoorTag: async (id) => {
        const url = `api/logistics/v1/outbound/doors/${id}/label`;
        const filename = `outbound_door_${id}.pdf`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = filename;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.log('[getTruckTag] error', e.toString());
        }
    },
    manifestTruck: async (outboundTruckID) => {
        const url = `api/logistics/v1/outbound/manifestableTrucks`;
        const sendParams = {
            outboundTruckID,
        };
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
        return response;
    },
    updateTruck: async (id, sendParams) => {
        const url = `api/logistics/v1/outbound/trucks/${id}`;
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
        return response;
    },
};

export { outboundTruckApi };
